import React from 'react';

interface DurationWithTooltipProps {
  start: string | Date;
  end: string | Date;
  className?: string;
}

function formatDuration(ms: number) {
  if (ms < 0) {
    return '—';
  }
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  }
  return `${seconds}s`;
}

const DurationWithTooltip: React.FC<DurationWithTooltipProps> = ({
  start,
  end,
  className = '',
}) => {
  const startDate = typeof start === 'string' ? new Date(start) : start;
  const endDate = typeof end === 'string' ? new Date(end) : end;
  const duration = formatDuration(endDate.getTime() - startDate.getTime());
  const fullDate = endDate.toLocaleString();
  return (
    <span className={className} title={fullDate}>
      {duration}
    </span>
  );
};

export default DurationWithTooltip;
